import React from 'react';
import { AttributeTextValue, Customer, SalesOrder, SimpleProduct } from "@msdyn365-commerce/retail-proxy";
import { ICultureInfoFormatter } from '@msdyn365-commerce/core-internal';
export interface IOrderConfirmationDetailProps {
  cultureFormatter: ICultureInfoFormatter;
  salesOrder: SalesOrder;
  customer: Customer | undefined;
  deliveryMode: string;
  orderedProducts: SimpleProduct[]
}

export const OrderConfirmationDetail: React.FC<IOrderConfirmationDetailProps> = ({salesOrder, cultureFormatter, customer, deliveryMode, orderedProducts}) => {

    const getProductDescription = (itemId: string): string => orderedProducts.find(p => p.ItemId === itemId)?.Description || '';

    const salesOrderAttrs = salesOrder.AttributeValues || [];
    const attr = salesOrderAttrs?.find(s => s.Name === "po-number") as AttributeTextValue;
    return (
      <div>
        <div className={'order-confirmation'}>
          <h1 className={'order-confirmation__header'}>Order Confirmation</h1>
          <i className={'order-confirmation__print'} onClick={() => window.print() } />
        </div>

        <div className={"order-information"}>
          <div className="order-information__wrapper">
            <div className={"order-information__heading"}>Order Information</div>
            <div className="order-information__details">
            <div className={"order-information__po-num"}>
                <p className={"order-information__copy--bold"}>Web Reference Number:</p>
                <p className={"order-information__copy--regular"}>{salesOrder.ChannelReferenceId}</p>
              </div>
              <div className={"order-information__po-num"}>
                <p className={"order-information__copy--bold"}>Sales Order Number:</p>
                <p className={"order-information__copy--regular"}>To be provided when order processed.</p>
              </div>
              {attr ? (
                <div className={"order-information__po-num"}>
                <p className={"order-information__copy--bold"}>PO Number:</p>
                <p className={"order-information__copy--regular"}>{attr.TextValue}</p>
              </div>
              ): undefined}
              
              <div className="order-information__date">
                <p className={"order-information__copy--bold"}>Order Date:</p>
                <p
                  className={"order-information__copy--regular"}>{cultureFormatter.formatDate(salesOrder.CreatedDateTime!, {
                  year: "numeric",
                  month: "short",
                  day: "2-digit"
                })}</p>
              </div>
            </div>
            {salesOrder.Comment ? (<div className="order-information__details">
              <div className={"order-information__comment"}>
                <p className={"order-information__copy--bold"}>Notes:</p>
                <p className={"order-information__copy--regular"}>{salesOrder.Comment}</p>
              </div>
            </div>) : null}
          </div>
          <div className="order-information__row">
            <div className="order-information__wrapper order-information__wrapper--two-third">
              <div className={"order-information__heading"}>Account Information</div>
              <div className="order-information__details">
                <div className={"order-information__acc-name"}>
                  <p className={"order-information__copy--bold"}>Account Name:</p>
                  <p className={"order-information__copy--regular"}>{customer?.FirstName}</p>
                </div>
                <div className="order-information__date">
                  <p className={"order-information__copy--bold"}>Account Number:</p>
                  <p className={"order-information__copy--regular"}>{customer?.AccountNumber}</p>
                </div>
              </div>
            </div>
            <div className="order-information__wrapper order-information__wrapper--one-third">
              <div className={"order-information__heading"}>Shipping Information</div>
              <div className="order-information__details order-information__details--col">
                <div className={"order-information__ship-address"}>
                  <p className={"order-information__copy--bold"}>Shipping Address:</p>
                  <p className={"order-information__copy--regular"}>{salesOrder.ShippingAddress?.Name}</p>
                  <p className={"order-information__copy--regular"}>{salesOrder.ShippingAddress?.FullAddress}</p>
                </div>
                <div className={"order-information__dlv-mode"}>
                  <p className={"order-information__copy--bold"}>Shipping Method:</p>
                  <p className={"order-information__copy--regular"}>{deliveryMode}</p>

                </div>
              </div>
            </div>
          </div>
        </div>
        <table className={"table"}>
          <thead className={"order-confirmation-header"}>
          <tr>
            <th>Line</th>
            <th>Item Id</th>
            <th>Description</th>
            <th>Price</th>
            <th>Quantity</th>
            <th>Total</th>
          </tr>
          </thead>
          <tbody>
          {salesOrder.SalesLines?.map((so, idx) => (
            <tr>
              <td>{so.LineNumber}</td>
              <td>{so.ItemId}</td>
              <td>{getProductDescription(so.ItemId!)}
                {so.Comment ? <><br /> <span className={'order-information__copy--bold'}>Notes:</span>
                <span className={"order-information__copy--regular"}>{so.Comment}</span></> : null }
              </td>
              <td>{cultureFormatter.formatCurrency(so.Price!)}</td>
              <td>{so.Quantity}</td>
              <td>{cultureFormatter.formatCurrency(so.TotalAmount!)}</td>
            </tr>
          ))}
          </tbody>
        </table>
        <div className={'order-confirmation__footer'}>
          <p className={"order-information__copy--bold"}>Order Total:</p>
          <p className={"order-information__copy--regular"}>{cultureFormatter.formatCurrency(salesOrder.TotalAmount!)}</p>

        </div>
      </div>

    );
}
